var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.982 0.0200027C18.8511 0.018407 18.7214 0.0442207 18.6011 0.0957846C18.4807 0.147348 18.3725 0.223521 18.2834 0.319404L10 8.58288L1.71657 0.319404C1.31736 -0.0797976 0.698603 -0.0797976 0.299401 0.319404C-0.0998004 0.718606 -0.0998004 1.33737 0.299401 1.73657L9.3014 10.6986C9.7006 11.0978 10.3194 11.0978 10.7186 10.6986L19.7006 1.71661C20.0998 1.31741 20.0998 0.698645 19.7006 0.299444C19.501 0.0998427 19.2415 4.21259e-05 19.002 4.21259e-05L18.982 0.0200027Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.8aefee0e427eec283ec871591ac0ed52.svg";
export { ForwardRef as ReactComponent };